import React, { useState, useEffect } from "react";
import { Modal, Button, Row, Col, Checkbox, Form, Input, message } from "antd";
import type { CheckboxChangeEvent } from "antd/es/checkbox";
import { nextTick } from "process";
import { RootStateOrAny, useSelector } from "react-redux";

type Props = {
  showModalForEstimate: boolean;
  toggleModal: (item: any) => void;
  handleAddAnother: (values: any) => void;
  form: any;
};

const AddOption = (props: Props) => {
  const { items, currentProject } = useSelector(
    (state: RootStateOrAny) => state.offlineData
  );

  const [isOnsite, setIsOnsite] = useState(false);
  const [address, setAddress] = useState("");

  useEffect(() => {
    const jobSiteAddress = `${
      items[currentProject].projectInfo?.clientName
        ? items[currentProject].projectInfo?.clientName + ","
        : ""
    } ${items[currentProject].projectInfo?.streetAddressOne}, ${
      items[currentProject].projectInfo?.streetAddressTwo
        ? items[currentProject].projectInfo?.streetAddressTwo + ", "
        : ""
    } ${items[currentProject].projectInfo?.city}, ${
      items[currentProject].projectInfo?.state
    }, ${items[currentProject].projectInfo?.zip}`;
    setAddress(jobSiteAddress);
  }, []);

  const onCheckSiteChange = (e: CheckboxChangeEvent) => {
    if (e.target.checked) {
      setAddress(props.form.getFieldValue("address"));
      setIsOnsite(true);
    } else {
      const jobSiteAddress = `${
        items[currentProject].projectInfo?.clientName
          ? items[currentProject].projectInfo?.clientName + ","
          : ""
      } ${items[currentProject].projectInfo?.streetAddressOne}, ${
        items[currentProject].projectInfo?.streetAddressTwo
          ? items[currentProject].projectInfo?.streetAddressTwo + ", "
          : ""
      } ${items[currentProject].projectInfo?.city}, ${
        items[currentProject].projectInfo?.state
      }, ${items[currentProject].projectInfo?.zip}`;
      setIsOnsite(false);
      setAddress(jobSiteAddress);
    }
  };

  const addAnother = () => {
    props.form
      .validateFields()
      .then((values: any) => {
        const address: string = props.form.getFieldValue("address");
        props.handleAddAnother({
          title: props.form.getFieldValue("title"),
          address: props.form.getFieldValue("address"),
          toggle: true,
        });
        if (isOnsite) {
          props.form.setFieldValue("address", address);
        }
      })
      .catch((err: Error) => {
        console.log(err);
      });
  };

  const checkEmpty = {
    validator(_: any, value: string) {
      if (value) {
        if (value.startsWith(" ")) {
          return Promise.reject(new Error("Invalid"));
        }
      }

      return Promise.resolve();
    },
  };

  return (
    <div>
      <Modal
        className="surface-modal"
        centered={true}
        open={props.showModalForEstimate}
        // onOk={props.toggleModal}
        onCancel={props.toggleModal}
        title={
          <h1 style={{ marginTop: 10 }} className="send-title-text">
            Add Options
          </h1>
        }
        footer={false}
      >
        <Form
          form={props.form}
          onFinish={props.handleAddAnother}
          layout="vertical"
          scrollToFirstError
          autoComplete="off"
        >
          <div>
            <Row justify="center">
              <Col span={24}>
                <div className="surface-container">
                  <h3 className="send-req-input-title">Option Titles</h3>

                  <Form.Item
                    name="title"
                    rules={[
                      {
                        required: true,
                        message: "Please enter!",
                      },
                      checkEmpty,
                    ]}
                  >
                    <Input className="form-input" />
                  </Form.Item>
                </div>

                <div className="surface-container">
                  <h3 className="send-req-input-title">Address</h3>

                  <Form.Item
                    name="address"
                    initialValue={address}
                    rules={[
                      {
                        required: true,
                        message: "Please enter!",
                      },
                      checkEmpty,
                    ]}
                  >
                    <Input className="form-input" />
                  </Form.Item>
                </div>

                <div className="surface-container">
                  <Checkbox onChange={onCheckSiteChange}>
                    Save address for other options
                  </Checkbox>
                </div>
              </Col>
            </Row>

            <Row justify="end" style={{ marginTop: 60 }}>
              <Col>
                <Button
                  key="back"
                  onClick={props.toggleModal}
                  className="cancel-btn"
                >
                  Cancel
                </Button>
              </Col>
              <Col>
                <Button
                  key="submit"
                  name="add"
                  type="primary"
                  className="send-btn"
                  htmlType="submit"
                >
                  Add
                </Button>
              </Col>
              <Col>
                <Button
                  name="addAnother"
                  className="send-btn"
                  type="primary"
                  onClick={addAnother}
                >
                  Add Another
                </Button>
              </Col>
            </Row>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default AddOption;
